import 'iconify-icon';
import Sdk from 'casdoor-js-sdk';

window.baseUrl = process.env.API_SERVER_URL || "";
window.assetsBaseUrl = process.env.ASSETS_BASE_URL || "";

const sdkConfig = {
  serverUrl: process.env.CASDOOR_SERVER_URL || "",
  clientId: process.env.CASDOOR_CLIENT_ID || "",
  organizationName: process.env.CASDOOR_ORGANIZATION_NAME || "",
  appName: process.env.CASDOOR_APP_NAME || "",
  redirectPath: process.env.CASDOOR_REDIRECT_PATH || "/",
};

const sdk = new Sdk(sdkConfig);

function getIconifyName(faClass) {
  if (!faClass) return '';
  if (faClass.includes(':')) {
    return faClass;
  }
  const parts = faClass.split(/\s+/);
  let prefix = 'fa6-solid';
  let name = '';
  for (const part of parts) {
    if (part === 'fa-regular' || part === 'far') {
      prefix = 'fa6-regular';
    } else if (part === 'fa-brands' || part === 'fab') {
      prefix = 'fa6-brands';
    } else if (part === 'fa-solid' || part === 'fas') {
      prefix = 'fa6-solid';
    } else if (part.startsWith('fa-')) {
      name = part.slice(3);
    }
  }
  return name ? `${prefix}:${name}` : faClass;
}

let applications = [];

let currentFilter = 'semua';
let currentSearch = '';
let searchDebounceTimer = null;

const loginView = document.getElementById('login-view');
const dashboardView = document.getElementById('dashboard-view');
const userProfileName = document.getElementById('userProfileName');

function mapApiResponseToSections(apiApps) {
  const categories = {
    "administrasi": {
      section: "Adm Umum dan Keuangan",
      deskripsi: "Tata kelola, kepegawaian, anggaran dan pelaporan internal",
      category: "administrasi",
      isMobileSection: false,
      apps: []
    },
    "pelayanan": {
      section: "Operasional & Pelayanan",
      deskripsi: "Pelayanan pelanggan, bacameter, billing dan kanal komunikasi",
      category: "pelayanan",
      isMobileSection: false,
      apps: []
    }
  };

  apiApps.forEach(item => {
    let linkLogin = item.link_login || '';

    const app = {
      name: item.nama,
      description: item.deskripsi,
      icon: item.icon,
      logo: item.logo,
      url: linkLogin,
      mobile: item.is_mobile === "1" || item.is_mobile === 1
    };

    const cat = item.category || "administrasi";
    if (!categories[cat]) {
      categories[cat] = {
        section: cat.charAt(0).toUpperCase() + cat.slice(1),
        deskripsi: "",
        category: cat,
        isMobileSection: false,
        apps: []
      };
    }
    categories[cat].apps.push(app);
  });

  return Object.values(categories).filter(section => section.apps.length > 0);
}

async function fetchApplications(userId) {
  try {
    const appListPath = process.env.API_APP_LIST_PATH || "/panel/portal/app-list";
    const cleanPath = appListPath.startsWith('/') ? appListPath.slice(1) : appListPath;
    const response = await fetch(`${window.baseUrl}${cleanPath}?id_user=${userId}`);
    if (!response.ok) throw new Error('Network response was not ok');
    const json = await response.json();
    if (json && Array.isArray(json.data)) {
      if (json.data.length > 0 && json.data[0].display_name && userProfileName) {
        userProfileName.textContent = json.data[0].display_name;
      }
      applications = mapApiResponseToSections(json.data);
      
      const filterTabBar = document.getElementById('filterTabBar');
      if (filterTabBar) {
        if (json.data.length > 8) {
          filterTabBar.classList.remove('hidden');
        } else {
          filterTabBar.classList.add('hidden');
        }
      }

      renderApps();
    }
  } catch (error) {
    console.error("Failed to fetch applications:", error);
    applications = [];
    renderApps();
  }
}

const urlParams = new URLSearchParams(window.location.search);
const hashParams = new URLSearchParams(window.location.hash.substring(1));
const token = urlParams.get('access_token') || urlParams.get('id_token') || urlParams.get('token') ||
  hashParams.get('access_token') || hashParams.get('id_token') || hashParams.get('token');
const code = urlParams.get('code') || hashParams.get('code');
const authError = urlParams.get('error') || urlParams.get('auth_error');
const authErrorDesc = urlParams.get('error_description') || urlParams.get('msg');

if (authError) {
  if (dashboardView) dashboardView.classList.add('hidden');
  if (loginView) loginView.classList.remove('hidden');
  const errorEl = document.getElementById('authErrorMsg');
  const errorTextEl = document.getElementById('authErrorText');
  if (errorEl && errorTextEl) {
    errorTextEl.textContent = authErrorDesc || (authError ? `Auth Error: ${authError}` : "Gagal melakukan verifikasi akun.");
    errorEl.classList.remove('hidden');
  }
  window.history.replaceState({}, document.title, window.location.pathname);
} else if (token) {
  try {
    const parsed = sdk.parseAccessToken(token);
    const payload = parsed ? parsed.payload : null;
    if (payload) {
      localStorage.setItem('user', JSON.stringify({
        name: payload.displayName || payload.name,
        role: payload.role || 'User',
        id: payload.id || payload.sub,
        avatar: payload.avatar || ''
      }));
    }
  } catch (e) {
    console.error("Failed to parse token:", e);
  }
  window.location.href = window.location.origin + window.location.pathname;
} else if (code) {
  if (loginView) loginView.classList.add('hidden');
  if (dashboardView) dashboardView.classList.add('hidden');
  
  sdk.exchangeForAccessToken()
    .then((tokenRes) => {
      const accessToken = tokenRes.access_token || tokenRes.id_token;
      if (accessToken) {
        const parsed = sdk.parseAccessToken(accessToken);
        const payload = parsed ? parsed.payload : null;
        if (payload) {
          localStorage.setItem('user', JSON.stringify({
            name: payload.displayName || payload.name,
            role: payload.role || 'User',
            id: payload.id || payload.sub,
            avatar: payload.avatar || ''
          }));
        }
      }
      window.location.href = window.location.origin + window.location.pathname;
    })
    .catch((err) => {
      console.error("Failed to exchange code:", err);
      window.location.href = window.location.origin + window.location.pathname + 
        `?auth_error=exchange_failed&msg=${encodeURIComponent(err.message || 'Gagal menukarkan kode otorisasi.')}`;
    });
} else {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    if (loginView) loginView.classList.add('hidden');
    if (dashboardView) dashboardView.classList.remove('hidden');
    if (userProfileName) userProfileName.textContent = user.name;

    const avatarWrap = document.getElementById('userProfileAvatarWrap');
    if (avatarWrap && user.avatar) {
      avatarWrap.innerHTML = `<img src="${user.avatar}" class="w-full h-full object-cover rounded-full" alt="${user.name}">`;
    }

    initSearch();

    const userId = user.id || "5a1836a8-dc81-4efb-ae26-22697ecb0a39";
    fetchApplications(userId);
  } else {
    if (dashboardView) dashboardView.classList.add('hidden');
    if (loginView) loginView.classList.remove('hidden');
  }
}

const btnLoginSSO = document.getElementById('btnLoginSSO');
if (btnLoginSSO) {
  btnLoginSSO.addEventListener('click', () => {
    sdk.signin_redirect();
  });
}

const btnLogout = document.getElementById("btnLogout");
if (btnLogout) {
  btnLogout.addEventListener("click", function (e) {
    e.preventDefault();
    localStorage.removeItem('user');
    const redirectUrl = window.location.origin + window.location.pathname;
    const casdoorLogoutUrl = `${sdkConfig.serverUrl}/api/logout?post_logout_redirect_uri=${encodeURIComponent(redirectUrl)}`;
    window.location.href = casdoorLogoutUrl;
  });
}

document.addEventListener('click', function (e) {
  const wrap = document.getElementById('userDropdownWrap');
  if (wrap && !wrap.contains(e.target)) {
    const menu = document.getElementById('userMenu');
    if (menu) menu.classList.add('hidden');
  }
});

function renderApps(filterCategory = currentFilter) {
  currentFilter = filterCategory;
  
  document.querySelectorAll('.filter-tab').forEach(tab => {
    tab.className = 'filter-tab px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 cursor-pointer text-gray-500 hover:text-gray-900 hover:bg-gray-50';
  });
  const activeTab = document.getElementById(`tab-${filterCategory}`);
  if (activeTab) {
    activeTab.className = 'filter-tab px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 cursor-pointer bg-blue-600 text-white shadow-md shadow-blue-500/10 active';
  }

  const appContainer = document.getElementById('app-content');
  if (!appContainer) return;
  appContainer.innerHTML = '';

  const filteredSections = currentFilter === 'semua'
    ? applications
    : applications.filter(s => s.category === currentFilter);

  const searchedSections = filteredSections.map(section => ({
    ...section,
    apps: section.apps.filter(app => {
      if (currentSearch) {
        return app.name.toLowerCase().includes(currentSearch);
      }
      return true;
    })
  })).filter(section => section.apps.length > 0);

  searchedSections.forEach((section, sIdx) => {
    const sectionEl = createSectionElement(section, sIdx, searchedSections.length);
    appContainer.appendChild(sectionEl);
  });
}

function createSectionElement(section, index, totalSections) {
  const div = document.createElement('div');
  div.className = currentSearch ? '' : 'app-section-anim';
  if (index === totalSections - 1) {
    div.style.marginBottom = '0';
  }
  if (!currentSearch) {
    div.style.animationDelay = `${0.1 + index * 0.08}s`;
  }

  const activeCount = section.apps.length;

  div.innerHTML = `
        <div class="portal-section-header">
            <div>
                <div class="portal-section-title-row">
                    <h2 class="portal-section-title">
                        ${section.section}
                    </h2>
                    ${section.isMobileSection ? `<span class="badge-apk">${section.tag}</span>` : ''}
                </div>
                <p class="portal-section-desc">
                    ${section.deskripsi || ''}
                </p>
            </div>
            <span class="portal-section-count">
                ${activeCount} APLIKASI
            </span>
        </div>
        <div class="app-grid">
            ${section.apps.map((app, aIdx) => createAppCardHtml(app, section, index, aIdx)).join('')}
        </div>
    `;
  return div;
}

function escapeHtmlAttribute(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function createAppCardHtml(app, section, sIdx, aIdx) {
  const isActive = true;
  const delay = (0.15 + sIdx * 0.08 + aIdx * 0.06).toFixed(2);

  let url = app.url || '';

  const isMobile = app.mobile;
  const btnLabel = isMobile ? 'Unduh Aplikasi' : 'Masuk Aplikasi';

  const onclickAction = isActive && url
    ? (isMobile
      ? `onclick="downloadFile('${url}')"`
      : `onclick="event.preventDefault(); window.open('${url}', '_self')"`)
    : '';

  const hasLogo = app.logo && app.logo !== '';
  const escapedDesc = escapeHtmlAttribute(app.description || '');
  const logoBaseUrl = window.assetsBaseUrl;

  return `
        <a
            href="${url}"
            class="card-link"
            ${onclickAction}
        >
            <div
                class="app-card ${currentSearch ? '' : 'app-card-anim'}"
                style="
                    ${currentSearch ? '' : `animation-delay:${delay}s;`}
                    opacity:${isActive ? '1' : '.5'};
                    cursor:${isActive ? 'pointer' : 'not-allowed'};
                "
            >

                <div class="app-card-body">
                    <div class="app-icon-box">
                        ${hasLogo
      ? `
                                    <img
                                        src="${logoBaseUrl}assets/images/logo/${app.logo}"
                                        alt="${app.name}"
                                        class="app-logo"
                                    >
                                `
      : `
                                     <iconify-icon
                                         icon="${getIconifyName(app.icon)}"
                                         width="28"
                                         height="28"
                                         style="color:#0c4da2;"
                                     ></iconify-icon>
                                 `
    }
                    </div>

                    <div class="app-title">
                        ${app.name}
                    </div>

                    <div class="app-desc" title="${escapedDesc}">
                        ${app.description || ''}
                    </div>
                </div>

                <div class="app-card-footer">
                    <span>${btnLabel}</span>

                    <iconify-icon
                        icon="fa6-solid:arrow-right"
                        style="font-size:13px;"
                    ></iconify-icon>
                </div>

            </div>
        </a>
    `;
}


function initSearch() {
  const searchInput = document.getElementById('searchInput');
  const clearSearch = document.getElementById('clearSearch');
  if (!searchInput) return;

  searchInput.addEventListener('input', function () {
    const val = this.value.trim();
    if (clearSearch) {
      if (val) {
        clearSearch.classList.remove('hidden');
      } else {
        clearSearch.classList.add('hidden');
      }
    }

    clearTimeout(searchDebounceTimer);
    searchDebounceTimer = setTimeout(() => {
      currentSearch = val.toLowerCase();
      renderApps(currentFilter);
    }, 300);
  });

  if (clearSearch) {
    clearSearch.addEventListener('click', () => {
      searchInput.value = '';
      currentSearch = '';
      clearSearch.classList.add('hidden');
      renderApps(currentFilter);
      searchInput.focus();
    });
  }
}

function downloadFile(url) {
  const a = document.createElement('a');
  a.href = url;
  a.download = '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

window.downloadFile = downloadFile;
window.renderApps = renderApps;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(new URL('sw.js', import.meta.url), { type: 'module' })
      .then((reg) => {
        console.log('Service Worker registered successfully:', reg.scope);
        // Cek update baru setiap 30 detik
        setInterval(() => {
          reg.update();
        }, 30000);
      })
      .catch((err) => console.error('Service Worker registration failed:', err));
  });

  // Reload halaman otomatis saat service worker baru mengambil alih
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
